class PhotoModifications {
  constructor(photos) {
    this.photos = [].concat(photos);
  }

  set(key, value) {
    this.photos.forEach((photo) => {
      photo.modified || (photo.modified = photo[key] != value);

      photo[key] = value;
    });
  }

  setFrom(source, ...keys) {
    keys.length || (keys = Object.keys(source)); // if there's no specific keys supplied just copy the source object lock stock

    keys.forEach((key) => this.set(key, source[key]));
  }

  addTo(key, increaseBy) {
    this.photos.forEach((photo) => {
      const value = photo[key] + increaseBy;
      photo.modified || (photo.modified = photo[key] != value);

      photo[key] = value;
    });
  }

  reset(...keys) {
    keys.forEach((key) => this.set(key, null));
  }

  touch() {
    return this.photos.map((photo) => {
      photo.modified = true;

      return photo;
    });
  }

  clear() {
    this.photos.forEach((photo) => {
      delete photo.modified;
      delete photo.make_new_copy;
    });
  }
}

export default PhotoModifications;
